import { createKsStore, type KsStoreHook } from '@siclop/kstone-vue'
import { Employee } from '../models/Employee'
import { EmployeeForm } from '../forms/EmployeeForm'
import { EmployeeFilter } from '../filters/EmployeeFilter'
import { EmployeeService } from '../services/EmployeeService'

/**
 * Pinia store for employee management
 */
export const useEmployeeStore: KsStoreHook<Employee, EmployeeForm, EmployeeFilter> = createKsStore({
  id: 'employees',
  modelClass: Employee,
  formClass: EmployeeForm,
  filterClass: EmployeeFilter,
  service: EmployeeService,
  uniqueField: 'id',
  labelField: (item) => item.fullName || `Employee #${item.id}`,
  signalREventName: 'EmployeeModel',
  isReferential: true
})
